// Force header to stay fixed using JavaScript
export const forceHeaderFixed = () => {
  const header = document.querySelector('header[role="banner"]');
  if (header) {
    header.style.position = "fixed";
    header.style.top = "0";
    header.style.left = "0";
    header.style.right = "0";
    header.style.zIndex = "9999";
    header.style.width = "100%";
  }
};

// Force modals to appear above header
export const forceModalZIndex = () => {
  const modals = document.querySelectorAll('[role="dialog"], .fixed.inset-0');
  modals.forEach((modal) => {
    if (modal.classList.contains("bg-black")) {
      modal.style.zIndex = "10000";
    }
  });
};

// Run on DOM load and periodically
export const initHeaderFix = () => {
  // Run immediately
  forceHeaderFixed();
  forceModalZIndex();

  // Run after DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    forceHeaderFixed();
    forceModalZIndex();
  });

  // Run on window load
  window.addEventListener("load", () => {
    forceHeaderFixed();
    forceModalZIndex();
  });

  // Run periodically to ensure it stays fixed
  setInterval(() => {
    forceHeaderFixed();
    forceModalZIndex();
  }, 1000);
};
